// src/features/uninsured/uninsuredItemSlice.ts

import { createSlice } from "@reduxjs/toolkit"
// import { broadcastMessage } from "@/types/broadcast"

export interface broadcastMessage {
  reference: string // "initial" | "encounter_created" | "encounter_deleted" | "encounter_first_visit_changed" | ...
  broadcastedPatientUuid: string | null
  broadcastedEncounterUuid?: string | null
  broadcastedInsuranceUuid?: string | null
  broadcastEventId?: string | null
  treatmentRoomItems?: any[]
}

const initialState: broadcastMessage = {
  reference: "initial",
  broadcastedPatientUuid: null,
  broadcastedEncounterUuid: null,
  broadcastEventId: null,
  treatmentRoomItems: undefined,
}

const broadcastSlice = createSlice({
  name: "broadcast",
  initialState,
  reducers: {
    setBroadcast(state, action) {
      return { ...state, ...action.payload }
    },
    // 모든 아이템을 초기화할 때
    clearBroadcast(state) {
      state.reference = "initial"
      state.broadcastedPatientUuid = null
      state.broadcastedEncounterUuid = null
      state.broadcastEventId = null
      state.treatmentRoomItems = undefined
    },
  },
})

export const { setBroadcast, clearBroadcast } = broadcastSlice.actions

export default broadcastSlice.reducer
